<template>
  <div class="main">
    <img class="frame" src="../assets/image/frame.png" alt="" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less">
.main {
  .frame {
    width: 100%;
    height: 100%;
  }
  width: 100%;
  height: 100%;
  padding: 2.6vw 5.21vw 6.25vw 5.21vw;
}
</style>
